const SET_IMAGE = 'SET_IMAGE';
const SET_IMAGES = 'SET_IMAGES';
const RESET = 'RESET';
const FIRST_INDEX = 0;

import { getField, updateField } from 'vuex-map-fields';
import ImageService from '@/services/image.service';
import DetectionService from '@/services/detection.service';

import Axios from 'axios';
import Constants from '../../constants/Constants';

export default {
	namespaced: true,

	state() {
		return {
			images: [],
			image: null,
			imageURI: '',
		};
	},

	actions: {
		async retrieveImages({ commit, rootState }, payload) {
			let response = await ImageService.getDetectedImageByLimit({
				user: payload.username,
				model_name: payload.model,
				limit: payload.limit,
			});

			let retrieveImagesList = await Promise.all(
				response.data
					.filter((element) => {
						return [true, 'true'].includes(element.is_detected);
					})
					.map(async (element) => {
						let detectedImageUrl = await ImageService.getPresignedUrl({
							file_name: element.detected_image_name,
							s3_key: element.s3_key_detected,
						});

						let rawImageUrl = await ImageService.getPresignedUrl({
							file_name: element.image_name,
							s3_key: element.s3_key,
						});

						let cdnCloudFormation = Constants.CDN_CLOUD_FORMATION.detectedImage;
						let s3BucketUrl = process.env.VUE_APP_S3_BUCKET_URL;

						let cdnImage = detectedImageUrl.data.link.replace(
							s3BucketUrl,
							cdnCloudFormation
						);
						let cdnRawImage = rawImageUrl.data.link.replace(
							s3BucketUrl,
							cdnCloudFormation
						);

						element.detectedImageURI = cdnImage;
						element.rawImageURI = cdnRawImage;
						element.imageType = 'detected';

						return element;
					})
			);

			const listImageDetect = retrieveImagesList.filter(
				(item) => item.show_image === true
			);

			if (rootState.detector.camera.isDetecting)
				listImageDetect[0].isPreviewResult = true;

			commit(SET_IMAGES, listImageDetect);
		},

		async uploadImage({ commit }, payload) {
			let fileName = payload.file.name;

			let formData = new FormData();

			formData.append('content', payload.file);

			formData.append('file_name', fileName);

			formData.append('user', payload.username);

			await ImageService.upload(formData);

			commit(SET_IMAGE, payload.file);
		},

		async onDownload({ commit }, imgUrl) {
			const data = await fetch(imgUrl);
			const blob = await data.blob();
			const blob_png = new Blob([blob], { type: 'image/png' });

			return new Promise((resolve) => {
				const reader = new FileReader();
				reader.readAsDataURL(blob_png);
				reader.onloadend = () => {
					const base64data = reader.result;
					resolve(base64data);
				};
			});
		},

		async presignUrlS3({ commit }, payload) {
			let imagePresignUrlS3 = await ImageService.getPresignedUrl({
				file_name: payload.file_name,
				s3_key: payload.s3_key,
			});
			return imagePresignUrlS3;
		},

		resetImages({ commit }) {
			commit(RESET);
		},

		addPreviewResult({ commit, state }, payload) {
			commit('UNSHIFT_IMAGES', {
				class: payload,
				isPreviewResult: true,
			});
		},
	},

	mutations: {
		updateField,

		SET_IMAGES(state, payload) {
			state.images = payload;
		},

		SET_IMAGE(state, payload) {
			state.image = payload;
		},

		RESET(state) {
			state.imagexs = [];
			state.image = null;
		},

		SET_STATE(state, payload) {
			Object.entries(payload).forEach(([key, value]) => {
				state[key] = value;
			});
		},
		UNSHIFT_IMAGES(state, payload) {
			state.images.unshift(payload);
		},
	},

	getters: {
		getField,
	},
};
